const Config = {
	appName: 'PEDIDO EDI',
	primaryColor: '#01386A',
	ITEM_PRECISION_ACCURACY: 85,
};

export default Config;
